import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FinDeNavCbemDto } from '../../Models/CBEM';
import { TableColDto } from "../../Models/Table";


@Injectable({
  providedIn: 'root'
})
export class CbemService{

  private apiUrl = environment.apiUrl;

  constructor(private http:HttpClient) {

  }

  getCBEM_list(): Observable<FinDeNavCbemDto[]> {
    return this.http.get<FinDeNavCbemDto[]>(`${this.apiUrl}/get-CBEM`);
  }

  getCBEM_Col(): Observable<TableColDto[]> {
    return this.http.get<TableColDto[]>(`${this.apiUrl}/get-CbemCol`);
  }

  updateBilling(payload: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/update-billing`, payload);
  }




}
